import { useEffect } from 'react';

import { View } from '../common/View';
import { usePageTitle } from '../PageTitleContext';
import { LoadComponent } from '../util/LoadComponent';

export function Reports() {
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle('Reports');
  }, []);

  return (
    <View style={{ flex: 1, minHeight: 'auto' }} data-testid="reports-page">
      <LoadComponent
        name="ReportRouter"
        message="Loading reports..."
        importer={() =>
          import(/* webpackChunkName: 'reports' */ './ReportRouter')
        }
      />
    </View>
  );
}
